var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#085488",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1329 -614) translate(1329 614)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.792
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.25L8.5 8.5 12.75 8.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlue);
export default __webpack_public_path__ + "static/media/clock-blue.e6eb9ff0ebaf4f1ff33eb9a04f563864.svg";
export { ForwardRef as ReactComponent };